export const PAYMENT_CONSTANTS = {
  PaymentGatewaySuccessResult: 'a',
};
export const INVOICE_LEVEL_PAYNOW = 'INVOICE_LEVEL_PAYNOW';
export const COMPLETION_APPROVED = 'COMPLETION_APPROVED';
export const COMPLETION_DECLINED = 'COMPLETION_DECLINED';
export const PREAUTH_REJECTED_AVS = 'PREAUTH_REJECTED_AVS';
